/**
 * Interval Photo Settings
 *
 * Extracted from customer_portal IntervalSetting.tsx.
 * Vehicle-specific interval value arrays and formatting.
 *
 * @packageDocumentation
 */

import { isX10 } from "./constraints";

import type { VehicleConfiguration } from "./constraints";

// ============================================================================
// Interval Values
// ============================================================================

export const X10_INTERVAL_VALUES = [0, 2, 3, 5, 7, 10, 15, 20, 30, 60];
export const X2S2_INTERVAL_VALUES = [0, 1, 2, 3, 5, 7, 10, 15, 20, 30, 60];

export interface IntervalOption {
  value: number;
  label: string;
}

export function formatInterval(seconds: number): string {
  if (seconds === 0) return "Off";
  return `${seconds} s`;
}

function createIntervalOption(value: number): IntervalOption {
  return { value, label: formatInterval(value) };
}

const x10IntervalOptions: IntervalOption[] = X10_INTERVAL_VALUES.map(createIntervalOption);
const x2S2IntervalOptions: IntervalOption[] = X2S2_INTERVAL_VALUES.map(createIntervalOption);

export function getIntervalOptions(vehicleConfig?: VehicleConfiguration): IntervalOption[] {
  return isX10(vehicleConfig) ? x10IntervalOptions : x2S2IntervalOptions;
}

export function getIntervalValues(vehicleConfig?: VehicleConfiguration): number[] {
  return isX10(vehicleConfig) ? X10_INTERVAL_VALUES : X2S2_INTERVAL_VALUES;
}
